//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'CanadianCTHeadRule',
  data() {
    return {
      form:{
        i_head:'0',
        i_gcs:'0',
        i_age:'0',
        i_bleed:'0',
        i_fx:'0',

        gcs:'0',
        open_skull:'0',
        basal_skull:'0',
        vomiting:'0',
        age:'0',
        amnesia:'0',
        mechanism:'0',

      },
      hasScore:false,
      disabled:false,
      defaultJson:{
        'Head injury due to trauma':'创伤性头部伤',
        'GCS ≥ 13':'GCS ≥ 13',
        'Age ≥ 16 years':'年龄≥16',
        'No bleeding disorder, no blood thinners':'没有出血疾病，没有血液稀释',
        'No obvious open skull fracture':'没有明显的开放性头骨骨折',
        "Inclusion Factors": "必要因素",
        "CT required (high risk)": "需要 CT 检查（高危）",
        "CT required (medium risk)": "需要 CT 检查（中危）",
        "Dangerous mechanism": "存在危险机制",
        "Sign(s) of basal skull fracture": "颅底骨折体征",
        "Age ≥ 65 years": "年龄 ≥ 65 岁",
        "The rule does not apply": "该规则不适用",
        "GCS score < 15 at 2 hrs after injury": "伤后 2 小时 GCS < 15",
        "Vomiting ≥ 2 episodes": "呕吐 ≥ 2 次",
        "basal skill fracture hint": "• 鼓室积血\n• 「熊猫」眼\n• CSF 耳漏 \/ 鼻漏\n• Battle 征",
        "CT not required": "无需行 CT 检查",
        "Pre-impact amnesia ≥ 30 min": "逆行性遗忘 ≥ 30 分钟",
        "dangerous mechanism hint": "• 行人被机动车撞倒\n• 驾驶者从机动车中甩出\n• 从 > 3 英尺（1 米）或 > 5 级台阶处摔倒",
        "Suspected open or depressed skull fracture": "疑似颅骨开放性或凹陷性骨折"
      },
      include:0,
      no_exclude:0,
      any_high_risk:0,
      any_low_risk:0,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
            form[key]=0
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      // i_head ? (i_gcs ? (i_age ? (i_bleed ? (i_fx ? 1 : 0) : 0) : 0) : 0) : 0
      let currentInclude = form.i_head ? (form.i_gcs ? (form.i_age ? (form.i_bleed ? (form.i_fx ? 1 : 0) : 0) : 0) : 0) : 0
      console.log(currentInclude);
      self.include = currentInclude

      // (gcs ? 2 : (open_skull ? 2 : (basal_skull ? 2 : (vomiting ? 2 : (age ? 2 : (amnesia ? 1 : (mechanism ? 1 : 0)))))))

      let result = (form.gcs ? 2 : (form.open_skull ? 2 : (form.basal_skull ? 2 : (form.vomiting ? 2 : (form.age ? 2 : (form.amnesia ? 1 : (form.mechanism ? 1 : 0)))))))
      self.hasScore = true
      return String(result)
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/CanadianCTHeadRule.vue